import React from 'react'
import { LabelComponentBuilder } from '../../store/itinerary/routes.utils'

export const extractNumber = (label = '') => {
  const matching = label.match(/^([0-9]+)(.*)$/)
  if (!matching) return [label]
  return matching.slice(1)
}

const StepUpNumber = ({ label, mainClassName, restClassName }) => {
  const formatted = extractNumber(label)
  return (
    <>
      <span className={mainClassName}>{formatted[0]}</span>
      <span className={restClassName}>{formatted[1]}</span>
    </>
  )
}

export const buildStepUpComponents = label => {
  const formatted = extractNumber(label)
  const components = [LabelComponentBuilder.text(formatted[0])]
  if (formatted[1]) components.push(LabelComponentBuilder.text(formatted[1], undefined, 'small'))
  return components
}

export default StepUpNumber
